import { render, staticRenderFns } from "./info.vue?vue&type=template&id=64bd226c&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"
import style0 from "./info.vue?vue&type=style&index=0&id=64bd226c&prod&lang=css"
import style1 from "./info.vue?vue&type=style&index=1&id=64bd226c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bd226c",
  null
  
)

export default component.exports